/* eslint-disable jsx-a11y/anchor-is-valid */
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import Link from 'next/link';
import SmartImage from '../../smartImage/smartImage';
import styles from './logoAddress.module.scss';

const logoPropType = PropTypes.shape({
  path: PropTypes.string,
  alt: PropTypes.string,
  link: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
});

export function Logo({ logo = { path: '', alt: '', link: '/' } }) {
  if (!logo?.path) return null;
  return (
    <Link href={logo.link || '/'}>
      <SmartImage
        className={styles.logo}
        loading="lazy"
        alt={logo.alt}
        src={logo.path}
        height={logo.height}
        width={logo.width}
      />
    </Link>
  );
}

Logo.propTypes = {
  logo: logoPropType,
};

export function Address({ address = '' }) {
  if (!address) return null;
  return <div className={styles.address}>{parse(`${address}`)}</div>;
}

Address.propTypes = {
  address: PropTypes.string,
};

export default function LogoAddress({
  logo = { path: '', alt: '', link: '/' },
  address = '',
}) {
  return (
    <div className={styles.logoAddress}>
      <Logo logo={logo} />
      <Address address={address} />
    </div>
  );
}

LogoAddress.propTypes = {
  logo: logoPropType,
  address: PropTypes.string,
};
